/** Formatting helpers shared by the FINE document surfaces
 * (FineDocumentsSection, FineComparisonReport). Distinct from
 * promoter/promoterFormat.ts on purpose: FINE values are numbers and
 * render with 0 fraction digits; promoter values are Decimal strings
 * with cents. */

export function formatEur(value: number | null): string {
  if (value == null) return "—";
  return value.toLocaleString("pt-PT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  });
}

export function formatPct(value: number | null): string {
  if (value == null) return "—";
  return `${value.toFixed(3)}%`;
}

export function RateTypeLabel({ type }: { type: string | null }) {
  switch (type) {
    case "fixed":
      return <>Fixa</>;
    case "variable":
      return <>Variável</>;
    case "mixed":
      return <>Mista</>;
    default:
      return <>—</>;
  }
}
